import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import PropTypes from "prop-types";

const Spinner = ({ className }) => <FontAwesomeIcon className={classNames("fa-spin", className)} icon="spinner" />;

Spinner.propTypes = {
  className: PropTypes.string,
};

export default Spinner;
